import SvgIcon from "@mui/icons-material/Menu";
import React from "react";
import { HashLink } from "react-router-hash-link";

function Footter() {
  const EmailSvg = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-[20px] h-[20px]"
      viewBox="0 0 24 24"
    >
      <path data-name="Path 1152" d="M0 0h24v24H0z" style={{ fill: "none" }} />
      <path
        data-name="Path 1153"
        d="M22 6a2.006 2.006 0 0 0-2-2H4a2.006 2.006 0 0 0-2 2v12a2.006 2.006 0 0 0 2 2h16a2.006 2.006 0 0 0 2-2zm-2 0-8 5-8-5zm0 12H4V8l8 5 8-5z"
        style={{ fill: "#bbb" }}
      />
    </svg>
  );
  const Tiktok = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="lg:w-[38px] lg:h-[38px] md:w-[30px] md:h-[30px] w-[38px] h-[38px]"
      viewBox="0 0 48 48"
    >
      <g data-name="Group 24893">
        <g
          data-name="Ellipse 54"
          style={{ stroke: "#fff", strokeWidth: "2px", fill: "none" }}
        >
          <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
          <circle cx="24" cy="24" r="23" style={{ fill: "none" }} />
        </g>
        <path
          data-name="Path 1187"
          d="M141.032 109.867v-3.707a4.939 4.939 0 0 1-5-5.019v-.031h-3.742v14.43a2.964 2.964 0 1 1-2.1-2.837v-3.822a6.79 6.79 0 0 0-.867-.053 6.714 6.714 0 1 0 6.716 6.711c0-.094 0-.188-.007-.28v-7.105c1.723 1.577 5 1.713 5 1.713z"
          transform="translate(-107.82 -87.683)"
          style={{ fill: "#fff" }}
        />
      </g>
    </svg>
  );
  const FaceBook = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="lg:w-[38px] lg:h-[38px] md:w-[30px] md:h-[30px] w-[38px] h-[38px]"
      viewBox="0 0 48 48"
    >
      <g data-name="Group 24895">
        <g
          data-name="Ellipse 56"
          style={{ stroke: "#fff", strokeWidth: "2px", fill: "none" }}
        >
          <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
          <circle cx="24" cy="24" r="23" style={{ fill: "none" }} />
        </g>
        <path
          data-name="Path 68431"
          d="M221.8 67.985h1.993a.5.5 0 0 0 .5-.5V64.5a.5.5 0 0 0-.5-.5H221.8a5.48 5.48 0 0 0-5.48 5.48v2.491h-2.491a.5.5 0 0 0-.5.5v2.989a.5.5 0 0 0 .5.5h2.491v8.967h3.985v-8.971h2.495a.5.5 0 0 0 .472-.341l1-2.989a.5.5 0 0 0-.472-.656h-3.487v-2.49a1.5 1.5 0 0 1 1.487-1.495z"
          transform="translate(-194.813 -50.462)"
          style={{ fill: "#fafafa" }}
        />
      </g>
    </svg>
  );
  const Thread = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="lg:w-[38px] lg:h-[38px] md:w-[30px] md:h-[30px] w-[38px] h-[38px] "
      viewBox="0 0 48 48"
    >
      <defs>
        <clipPath id="99wp5x6xsa">
          <path
            data-name="Rectangle 8034"
            style={{ fill: "#fff" }}
            d="M0 0h18.455v21.146H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Group 24896">
        <g
          data-name="Ellipse 56"
          style={{ stroke: "#fff", strokeWidth: "2px", fill: "none" }}
        >
          <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
          <circle cx="24" cy="24" r="23" style={{ fill: "none" }} />
        </g>
        <g data-name="Group 24834">
          <g
            data-name="Group 24832"
            style={{ clipPath: "url(#99wp5x6xsa)" }}
            transform="translate(14.772 13.427)"
          >
            <path
              data-name="Path 68424"
              d="M9.289 21.147c-4.222 0-7.708-2.2-8.848-6.644A17.346 17.346 0 0 1 .31 7.35C.712 5.314 2.02 2.484 4.382 1.2a11.189 11.189 0 0 1 7.245-.984 8.372 8.372 0 0 1 5.146 3.066 9.049 9.049 0 0 1 1.682 3.482l-1.77.345.885-.173-.884.176a7.35 7.35 0 0 0-1.336-2.721 6.581 6.581 0 0 0-4.1-2.412 9.4 9.4 0 0 0-6 .81C3.3 3.839 2.342 6.37 2.079 7.7a15.673 15.673 0 0 0 .109 6.355 6.542 6.542 0 0 0 3.741 4.631 9.554 9.554 0 0 0 6.355.211 5.15 5.15 0 0 0 3.325-3.29 3.339 3.339 0 0 0-1.628-3.936 4.977 4.977 0 0 1-2.612 4.05c-2.1.958-4.846.184-5.763-1.626a3.339 3.339 0 0 1 .066-3.15 4.1 4.1 0 0 1 3.6-1.869 13.837 13.837 0 0 1 2.922.128 2.565 2.565 0 0 0-2.456-2.462 2.716 2.716 0 0 0-2.644 1.174l-1.538-.943A4.516 4.516 0 0 1 9.807 4.94c2.465.094 4.094 1.921 4.253 4.77a5.212 5.212 0 0 1 3.3 6.314 6.884 6.884 0 0 1-4.532 4.592 11.908 11.908 0 0 1-3.544.532m.886-10.292c-1.059 0-2.408.071-2.941.992a1.518 1.518 0 0 0-.019 1.432c.472.93 2.222 1.341 3.405.8.913-.417 1.488-1.517 1.623-3.037a10.426 10.426 0 0 0-2.068-.188"
              transform="translate(0 -.001)"
              style={{ fill: "#fff" }}
            />
          </g>
        </g>
      </g>
    </svg>
  );
  const Instagram = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="lg:w-[38px] lg:h-[38px] md:w-[30px] md:h-[30px] w-[38px] h-[38px]"
      viewBox="0 0 48 48"
    >
      <g data-name="Group 24894">
        <g
          data-name="Ellipse 55"
          style={{ stroke: "#fff", strokeWidth: "2px", fill: "none" }}
        >
          <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
          <circle cx="24" cy="24" r="23" style={{ fill: "none" }} />
        </g>
        <path
          data-name="Path 68423"
          d="M13.7 3.141c-4.327 0-8.437-.385-10.006 3.643-.648 1.664-.554 3.824-.554 6.918 0 2.715-.087 5.266.554 6.917 1.566 4.031 5.709 3.644 10 3.644 4.144 0 8.416.431 10-3.644.65-1.68.554-3.809.554-6.917 0-4.126.228-6.79-1.773-8.789-2.026-2.026-4.766-1.772-8.788-1.772zm-.946 1.9c9.027-.014 10.175-1.018 9.541 12.922-.225 4.93-3.979 4.389-8.594 4.389-8.414 0-8.656-.241-8.656-8.658 0-8.515.667-8.649 7.708-8.656zM19.335 6.8A1.267 1.267 0 1 0 20.6 8.064 1.267 1.267 0 0 0 19.335 6.8zM13.7 8.278a5.423 5.423 0 1 0 5.42 5.422 5.423 5.423 0 0 0-5.42-5.422zm0 1.9c4.654 0 4.66 7.041 0 7.041s-4.662-7.037 0-7.037z"
          transform="translate(10.302 10.296)"
          style={{ fill: "#fff" }}
        />
      </g>
    </svg>
  );
  const PhoneSvg = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-[20px] h-[20px]"
      viewBox="0 0 24 24"
    >
      <path data-name="Path 1154" d="M0 0h24v24H0z" style={{ fill: "none" }} />
      <path
        data-name="Path 1155"
        d="M6.54 5a12.312 12.312 0 0 0 .45 2.59l-1.2 1.2A14.826 14.826 0 0 1 5.03 5h1.51m9.86 12.02a12.753 12.753 0 0 0 2.6.45v1.49a15.426 15.426 0 0 1-3.8-.75l1.2-1.19M7.5 3H4a1 1 0 0 0-1 1 17 17 0 0 0 17 17 1 1 0 0 0 1-1v-3.49a1 1 0 0 0-1-1 11.407 11.407 0 0 1-3.57-.57.839.839 0 0 0-.31-.05 1.024 1.024 0 0 0-.71.29l-2.2 2.2a15.149 15.149 0 0 1-6.59-6.59l2.2-2.2a1 1 0 0 0 .25-1.02A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1z"
        style={{ fill: "#bbb" }}
      />
    </svg>
  );
  const Copyright = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="xxs:w-[16px] h-[16px] w-[22px] h-[22px]"
      viewBox="0 0 24 24"
    >
      <g style={{ opacity: ".95" }}>
        <path
          data-name="Path 1150"
          d="M0 0h24v24H0z"
          style={{ fill: "none" }}
        />
        <path
          data-name="Path 1151"
          d="M10.08 10.86a2.557 2.557 0 0 1 .3-.87 1.749 1.749 0 0 1 .59-.62 1.775 1.775 0 0 1 .91-.23 1.813 1.813 0 0 1 .63.13 1.612 1.612 0 0 1 .52.36 1.926 1.926 0 0 1 .34.53 1.751 1.751 0 0 1 .14.64h1.79a3.58 3.58 0 0 0-.28-1.29 3 3 0 0 0-.7-1.01 3.266 3.266 0 0 0-1.08-.66 3.863 3.863 0 0 0-1.39-.23 3.908 3.908 0 0 0-1.7.34 3.439 3.439 0 0 0-1.2.92 3.759 3.759 0 0 0-.71 1.36A5.857 5.857 0 0 0 8 11.87v.27a5.855 5.855 0 0 0 .23 1.64 3.635 3.635 0 0 0 .71 1.35 3.414 3.414 0 0 0 1.2.91 4.058 4.058 0 0 0 1.7.34 3.814 3.814 0 0 0 1.32-.23 3.411 3.411 0 0 0 1.08-.63 3.052 3.052 0 0 0 .74-.94 2.692 2.692 0 0 0 .3-1.15h-1.79a1.424 1.424 0 0 1-.15.58 1.472 1.472 0 0 1-.36.46 1.575 1.575 0 0 1-.52.3 1.986 1.986 0 0 1-.6.1 1.7 1.7 0 0 1-.89-.23 1.749 1.749 0 0 1-.59-.62 2.613 2.613 0 0 1-.3-.88 6.74 6.74 0 0 1-.08-1v-.27a6.663 6.663 0 0 1 .08-1.01zM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8.011 8.011 0 0 1-8 8z"
          style={{ fill: "#bbb" }}
        />
      </g>
    </svg>
  );
  const handleSocialRedirect = (platform) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const urls = {
      tiktok: {
        mobile: "https://www.tiktok.com/@fitstreak.official",
        desktop: "https://www.tiktok.com/@fitstreak.official",
      },
      instagram: {
        mobile: "instagram://user?username=fitstreak.official",
        desktop: "https://www.instagram.com/fitstreak.official",
      },
      threads: {
        mobile: "https://www.threads.net/@fitstreak.official",
        desktop: "https://www.threads.net/@fitstreak.official",
      },
      facebook: {
        mobile: "fb://page?id=<PageID>", // Replace <PageID> with the actual page ID if available
        desktop:
          "https://www.facebook.com/people/Fit-Streak/61569433709778/?mibextid=wwXIfr&rdid=wHLshzlCd7b2IuiD&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FeyRkR2ugF47MnqGt%2F%3Fmibextid%3DwwXIfr",
      },
    };

    const selectedPlatform = urls[platform];
    if (selectedPlatform) {
      if (isMobile) {
        // Redirect to the app for mobile users
        window.location.href = selectedPlatform.mobile;
      } else {
        // Open in a new tab for desktop users
        window.open(selectedPlatform.desktop, "_blank");
      }
    } else {
      console.error("Platform not recognized");
    }
  };

  const LocationSvg = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="xxs:w-[34px] xxs:w-[34px] w-[26px] h-[26px]"
      viewBox="0 0 24 24"
    >
      <path data-name="Path 1156" d="M0 0h24v24H0z" style={{ fill: "none" }} />
      <path
        data-name="Path 1157"
        d="M11.984 2A6.985 6.985 0 0 0 5 9c0 5.247 6.984 12.992 6.984 12.992S18.968 14.242 18.968 9a6.985 6.985 0 0 0-6.984-7z"
        transform="translate(.016 .006)"
        style={{ fill: "#bbb" }}
      />
      <circle
        data-name="Ellipse 2"
        cx="3.771"
        cy="3.771"
        r="3.771"
        transform="translate(8.229 5.231)"
        style={{ fill: "#1c1c1c" }}
      />
    </svg>
  );
  return (
    <div className="flex flex-col w-full">
      <div className="mt-6  md:mt-10 flex  m-auto flex-col md:flex-row w-[95%]  lg:w-[96%] xl:w-[85%] 2xl:w-[80%]  py-6 h-auto p-10  justify-between">
        <div className="flex  flex-col w-full  text-center md:text-left md:w-max lg:w-[300px] xl:w-[400px] 2xl:w-[450px] p-2">
          <div className="flex flex-row space-x-2  py-1 aling-center h-auto w-max m-auto md:m-0 ">
            <img src="/logo.png" alt="logo" className=" h-6 sm:h-8 w-auto" />
            <span className="text-white font-[700] text-lg sm:text-2xl">
              Fit Streak
            </span>
          </div>
          <p className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base  mt-4 md:mt-6 text-nav_option">
            Stay connected with Fit Streak! Follow us on social media for
            updates, tips, and motivation. Don’t forget to explore our site for
            classes from professionals and membership options tailored to your
            fitness goals.
          </p>
        </div>
        <div className="flex flex-col w-full lg:w-[120px] xl:w-[150px] 2xl:w-[180px] mt-6 md:mt-0 md:text-left text-center ">
          <p className="text-lg md:text-base lg:text-base xl:text-base mt-4 md:mt-6 text-white">
            Company
          </p>
          <HashLink
            to="/#"
            className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base mt-4 md:mt-6 text-nav_option hover:text-white"
          >
            Home
          </HashLink>
          <HashLink
            to="/#Aboutus"
            className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base mt-4 md:mt-6 text-nav_option hover:text-white"
          >
            About Us
          </HashLink>
          <HashLink
            to="/#Whyus"
            className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base mt-4 md:mt-6 text-nav_option hover:text-white"
          >
            Why Us
          </HashLink>
          <HashLink
            to="/#MemberShip"
            className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base mt-4 md:mt-6 text-nav_option hover:text-white"
          >
            Membership
          </HashLink>
          <HashLink
            to="/#trainner"
            className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base mt-4 md:mt-6 text-nav_option hover:text-white"
          >
            Our Trainers
          </HashLink>
        </div>
        <div className="flex flex-col w-full lg:w-[120px] xl:w-[150px] 2xl:w-[180px] mt-6 md:mt-0 md:text-left text-center ">
          <p className="text-lg md:text-base lg:text-base xl:text-base  mt-4 md:mt-6 text-white">
            Classes
          </p>
          <HashLink
            to="/#WeightLoss"
            className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base  mt-4 md:mt-6 text-nav_option hover:text-white"
          >
            Weight loss
          </HashLink>
          <HashLink
            to="/#BasicYoga"
            className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base  mt-4 md:mt-6 text-nav_option hover:text-white"
          >
            Basic Yoga
          </HashLink>
          <HashLink
            to="/#BodyBuilding"
            className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base  mt-4 md:mt-6 text-nav_option hover:text-white"
          >
            Body Building
          </HashLink>
          <HashLink
            to="/#Calisthenics"
            className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base  mt-4 md:mt-6 text-nav_option hover:text-white"
          >
            Calisthenics
          </HashLink>
        </div>
        <div className="flex p-2 flex-col w-full lg:w-[250px] xl:w-[300px] 2xl:w-[350px] mt-6 md:mt-0 md:text-left text-center">
          <p className="text-lg md:text-base   mt-4 md:mt-6 text-white">
            Contact
          </p>
          <div className="flex flex-row item-center space-x-2 mt-4 md:mt-6 md:m-0 m-auto w-max">
            <EmailSvg />
            <HashLink
              to="mailto:fitstreakgym@gmail.com"
              className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base   text-nav_option hover:text-white "
            >
              fitstreakgym@gmail.com
            </HashLink>
          </div>
          <div className="flex flex-row item-center space-x-2 mt-4 md:mt-6 md:m-0 m-auto w-max">
            <PhoneSvg />
            <HashLink
              to="tel:+923315555933"
              className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base   text-nav_option hover:text-white"
            >
              +92 331 5555933
            </HashLink>
          </div>
          <div className="flex flex-row item-center space-x-2 mt-4 md:mt-6 md:m-0 m-auto   ">
            <LocationSvg />
            <a
              href="#"
              className="text-base sm:text-base md:text-sm lg:text-sm xl:text-base   text-nav_option hover:text-white cursor-pointer"
              onClick={() => {
                const isMobile = /iPhone|iPad|iPod|Android/i.test(
                  navigator.userAgent
                );
                const isSmallScreen = window.innerWidth < 780; // Check for screen width

                if (isMobile) {
                  window.location.href =
                    "geo:0,0?q=Near+UBL+Bank,+Central+District+Bahria+Orchard+Lahore";
                } else {
                  // For larger screens, open in Google Maps web
                  window.open(
                    "https://www.google.com/maps/place/Fit+Streak/@31.3174086,74.2195511,17z/data=!3m1!4b1!4m6!3m5!1s0x3919abb3ea59059f:0x3ba4cef1ed9fb3e1!8m2!3d31.3174086!4d74.2195511!16s%2Fg%2F11lz54kgyv?entry=ttu&g_ep=EgoyMDI1MDEyMi4wIKXMDSoASAFQAw%3D%3D",
                    "_blank"
                  );
                }
              }}
            >
              Plaza 147, Central Commercial, Bahria Orchard, Lahore
            </a>
          </div>
          <div className="flex flex-row item-center space-x-6 mt-4 md:mt-6 md:m-0 m-auto w-max ">
            <button
              className="bg-none border-none p-0"
              onClick={() => handleSocialRedirect("tiktok")}
            >
              <Tiktok />
            </button>
            <button
              className="bg-none border-none p-0"
              onClick={() => handleSocialRedirect("instagram")}
            >
              <Instagram />
            </button>
            <button
              className="bg-none border-none p-0"
              onClick={() => handleSocialRedirect("facebook")}
            >
              <FaceBook />
            </button>
            <button
              className="bg-none border-none p-0"
              onClick={() => handleSocialRedirect("threads")}
            >
              <Thread />
            </button>
          </div>
        </div>
      </div>
      <div className=" flex  m-auto  w-[95%]  lg:w-[96%] xl:w-[85%] 2xl:w-[80%]   h-auto  pl-10 pb-10 space-x-3  md:item-center justify-center md:justify-start">
        <Copyright />
        <h1 className="text-base xxs:text-xs m-auto md:m-0 sm:text-base md:text-sm lg:text-sm xl:text-base    text-nav_option flex flex-row item-center">
          {" "}
          Copyrights 2024 All rights reserved
        </h1>
      </div>
    </div>
  );
}

export default Footter;
